
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/options",
      function () {
        return require("private-next-pages/options/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/options"])
      });
    }
  